/** Returns error message display when calling usePROVIDER at location outside PROVIDER context. */
export const providerErrorMessage = (provider: string) => `use${provider} must be used within a ${provider}Provider.`